/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the type of target for a rollout.
 */
export type RolloutTargetType = 'DEPLOYMENTS' | 'ORG_WITH_OAUTH_APPS';

export const RolloutTargetType = {

    DEPLOYMENTS: 'DEPLOYMENTS' as RolloutTargetType,

    ORG_WITH_OAUTH_APPS: 'ORG_WITH_OAUTH_APPS' as RolloutTargetType
};

